/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/pe-icon-7-stroke.css";
import "assets/css/knoa.css";

import AuthLayout from "./layouts/Auth.jsx";
import AdminLayout from "./layouts/Admin.jsx";

import i18n from "./i18n";
import { I18nextProvider } from 'react-i18next';

import "react-grid-layout/css/styles.css";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'react-tooltip/dist/react-tooltip.css';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <I18nextProvider i18n={i18n}>
        <HashRouter>
            <>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    className="toast-container"
                />
                <Switch>
                    <Route path="/auth" render={props => <AuthLayout {...props} />} />
                    <Route path="/admin" render={props => <AdminLayout {...props} />} />
                    <Redirect from="*" to="/auth/login" />
                </Switch>
            </>
        </HashRouter>
    </I18nextProvider>
);
